import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-65de3653"),n=n(),_popScopeId(),n)
const _hoisted_1 = { style: {"position":"relative","background-color":"#111111"} }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("video", {
  id: "videoElement",
  style: {"width":"100%"}
}, null, -1))
const _hoisted_3 = { style: {"position":"absolute","width":"100%","height":"100%","top":"0"} }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_van_loading = _resolveComponent("van-loading")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      (_ctx.loading)
        ? (_openBlock(), _createBlock(_component_van_loading, { key: 0 }))
        : _createCommentVNode("", true)
    ])
  ]))
}